import toast from 'react-hot-toast';

/**
 * Copies plain text to the clipboard and confirms it with a toast. Returns whether the copy
 * happened, so a button can show its "Copied" state only when it did. The browser can refuse the
 * write (no permission, insecure context, no clipboard API): the user then gets an error toast
 * instead of a "Copied" that never happened (AMP-150).
 */
export async function copyText(text: string, successMessage: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(successMessage);
    return true;
  } catch {
    toast.error('Could not copy to clipboard');
    return false;
  }
}
